module.exports = __webpack_public_path__ + "img/1-2.eff7d56f.svg";